import axios from "axios";
import { IWidgetResponse } from "../Base/Base.types";
import {ITopInTransitLanes} from "./TopInTransitLanes.types";

export default class TopInTransitLanesApi {
    static async getData({queryKey}: any) {
        //eslint-disable-next-line
        const [_, rawQuery] = queryKey;
        try {
            let res = await axios.get(`/TopInTransitLanes`, {params: rawQuery});
            return res.data as IWidgetResponse<ITopInTransitLanes>;
        } catch (e: any) {
            console.error('Could not get TopInTransitLanes data: ', e.message);
            return undefined;
        }
    }
}